export enum TreeViewLookupTypes {
  PayRates = 'Pay Rates',
  InsuranceStatus = 'Insurance Status',
  Reimbursements = 'Reimbursements',
  HousingType = 'Housing Type',
  BonusType = 'Bonus Type',
  AdditionalCostType = 'Additional Cost Type',
}

export enum AssignmentSplitContainerFields {
  Travel = 'Travel',
  RequestedTimeOff = 'Requested Time Off',
  Benefits = 'Benefits',
  Reimbursements = 'Reimbursements',
  Bonuses = 'Bonuses',
  BillRates = 'Bill Rates',
  PayRates = 'Pay Rates',
  AllowancesPerDiem = 'Allowances Per Diem',
  Housing = 'Housing',
  AdditionalCosts = 'Additional Costs',
  AssignmentTitle = 'Assignment Title',
}
export enum AssignmentSplitContainerTitles {
  AssignmentTitle = 'Assignment Title',
  SplitTitle = 'Split Title',
  NoSplitCreatedTitle = 'Split Not Created',
}

/**
 * Enum for BonusType - might need to replace this with bonus category
 */
export enum MarginBonusTypes {
  AMNCompletion = 'AMN Completion',
  AMNSignOn = 'AMN Sign On',
  FacilityCompletion = 'Facility Completion',
  FacilitySignOn = 'Facility Sign On',
  Inconvenience = 'Inconvenience',
}
